import { PaymentPlanStatus } from '@mews-commander/data-access';
import { Tag } from '@optimus-web/core';
import { LocalizedEnum } from '@mews/framework';
import { getTagVariantFromPaymentPlanStatus } from './utils';

export const PaymentPlanStatusTag = ({ status, outline = true }: { status: PaymentPlanStatus; outline?: boolean }) => (
    <Tag variant={getTagVariantFromPaymentPlanStatus(status)} outline={outline}>
        <LocalizedEnum prefix="PaymentPlanStatus" value={status} />
    </Tag>
);
